import { i18n } from "@lingui/core";

export type Locale = "cs" | "en";

export function activateLocale(locale?: Locale) {
  if (!locale) return;

  i18n.activate(locale);
}

export function getPreferredLanguage(savedLanguage?: Locale) {
  const browserLanguage = navigator.language === "cs" ? "cs" : "en";

  return savedLanguage ?? browserLanguage ?? "en";
}
